import { SET_ALERT_MESSAGES } from "./actionTypes";

export const setAlertMessage = (messages) => {
    return {type: SET_ALERT_MESSAGES, messages}
}